import * as React from 'react';
import { flow, each, get } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { IConviction } from '../../../../../../data/api/models';
import Conviction from '../Conviction';
import {Button} from 'react-bootstrap';

interface IConvictionsProps {
  convictions: IConviction[];
  convictionDataPath: string;
  fields: any;
  dispatch: any;
  change: any;
  renderDefinition: any;
  convictionOptions: any;
  convictionDescriptions: any;
}

const defaults = {
  code: '',
  description: '',
  date: '',
  points: 0,
  banned: 0,
  fine: 0,
};

class Convictions extends React.Component<IConvictionsProps> {
  public addConviction = () => {
    const { fields } = this.props;

    fields.push(defaults);
  }

  public deleteConviction = (index) => {
    const { fields } = this.props;

    fields.remove(index);
  }

  public render() {
    const { fields, convictions, dispatch, change, convictionOptions, convictionDescriptions } = this.props;

    return (
      <div>
        {fields.map((conviction, index) => {
          return (
            <div key={index}>
              <Conviction
                name={conviction}
                conviction={convictions[index]}
                index={index}
                dispatch={dispatch}
                change={change}
                convictionOptions={convictionOptions}
                convictionDescriptions={convictionDescriptions}
                removable={fields.length > 1}
                deleteConviction={this.deleteConviction}
              />
              {index + 1 !== fields.length && (
                <hr />
              )}
            </div>
          );
        })}
        {fields.length < 20 && (
          <div className="margin-bottom">
            <Button
              bsStyle="primary"
              className="btn-postcode"
              type="button"
              onClick={this.addConviction}
            >
              {`Add${fields.length < 1 ? '' : ' Another'} Conviction`}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
      (state: IStore, props: IConvictionsProps) => {
        const convictions = selector(state, props.convictionDataPath + '.convictions');

        return {
        quote: state.quote,
        convictions,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(Convictions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Convictions/index.tsx